module.exports = __webpack_public_path__ + "img/logo.4869e47c.svg";